<template>
    <v-dialog max-width="80%" persistent v-model="show">
        <v-card>
            <v-card-title class="headline">
                {{ "All" | t }} {{ direction | t}}
                <v-spacer />

            <v-btn icon @click="closeModal()">
                <v-icon>close</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-text>
                <vuecal
                        v-if="shipments[direction]"
                        :locale="vuecalLocale"
                        :events="shipments[direction]"
                        :disable-views="['years', 'year', 'day', 'month']"
                        hide-view-selector
                        show-week-numbers
                        hide-weekends
                        :time-from="timeFrom"
                        :time-to="timeToDisplay"
                        :time-step="30"
                        :time-cell-height="35"
                        :cell-click-hold="false"
                        :drag-to-create-event="false"
                        :events-on-month-view="'short'"
                        :disable-days="disabledDates"
                        ref="vuecal"
                        @ready="onReady"
                >
                    <template #event="{ event, view }">
                        <!-- Week View -->
                        <div @click="handleCalendarEventClick(event.id)"
                             :class="[
                              'existing-event',
                              event.id === $route.params.shipmentId ? 'current-event' : `status-${event.status}`
                            ]"
                             v-if="view === 'week'">
                            <div class="vuecal__event-title font-weight-bold company-name" v-html="event.title"></div>

                            <small class="vuecal__event-time">
                                <strong>{{ `${ t("Car nr") }:` }}</strong> <span>{{
                                    event.vehicle_reg_number
                                }}</span><br/>
                                <strong>{{ `${ t("Start") }:` }}</strong> <span>{{
                                    event.start.formatTime("HH:mm")
                                }}</span><br/>
                                <strong>{{ `${ t("End") }:` }}</strong> <span>{{ event.end.formatTime("HH:mm") }}</span>
                            </small>
                        </div>

                        <!-- Month View -->
                        <div @click="handleCalendarEventClick(event.id)"
                             class="month-event" :class="{
                                'current-event-month': $route.params.shipmentId && event.id === $route.params.shipmentId,
                                 'done-event-month': event.status === 'done'
                            }" v-else>
                            <div>
                                <span class="company-name">{{ event.title }}: </span>
                                <span class="event-times">{{
                                        event.start.formatTime("HH:mm")
                                    }}-{{ event.end.formatTime("HH:mm") }}</span>
                            </div>
                        </div>
                    </template>

                </vuecal>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { helperMixin } from "@/mixins/helper-mixin";
import VueCal from "vue-cal";
import holidays from "@/pages/shipment/tab-items/data-item/public-holidays.json";
import { mapState, mapActions } from "vuex";

export default {
    mixins: [helperMixin],
    components: { vuecal: VueCal },
    props: {
        direction: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timeFrom: 480,
            timeToDisplay: 960,
        };
    },
    mounted() {
    },
    computed: {
        ...mapState("ShipmentStore", ["shipments", "vuecalLocale"]),
        disabledDates() {
            return Object.values(holidays).flatMap(year => Object.values(year));
        },
    },
    methods: {
        ...mapActions("ShipmentStore", ["getShipmentData"]),
        closeModal() {
            this.$emit('close');
        },
        onReady() {
            setTimeout(() => {
                try {
                    const now = new Date();
                    this.$refs.vuecal.switchView('week', now.format("YYYY-MM-DD HH:mm"));
                } catch (e) {
                    console.log(e);
                    setTimeout(() => {
                        const now = new Date();
                        this.$refs.vuecal.switchView('week', now.format("YYYY-MM-DD HH:mm"));
                    }, 500);
                }
            }, 500);
        },
        async handleCalendarEventClick(shipmentId) {
            const properRoute = this.$route.name === "shipment-list" || this.$route.name === "shipment-view"
            if (properRoute && parseInt(shipmentId) !== parseInt(this.$route.params.shipmentId)) {
                this.$router.push({ name: "shipment-view", params: { shipmentId: shipmentId } });
                await this.getShipmentData(shipmentId);
            }
        }

    }
};
</script>

<style scoped>
.existing-event {
    border-radius: 6px;
    width: 98.5%;
    height: 99%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    cursor: pointer;
}

.month-event {
    text-align: left;
    padding-left: 0.3em;
    border-radius: 4px;
    width: 98.5%;
    height: 98%;
    margin-bottom: 2px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
}

.current-event {
    background: rgba(252, 37, 37, 0.15) !important;
}

.current-event-month {
    background: rgba(252, 37, 37, 0.15) !important;
}

.status-pending {
    background: rgba(252, 37, 37, 0.15);
}

.status-waiting {
    background: rgba(0, 123, 255, 0.15);
}

.status-done {
    background: rgba(40, 167, 69, 0.15);
}

.status-month-pending {
    background: rgba(252, 37, 37, 0.15);
}

.status-month-waiting {
    background: rgba(0, 123, 255, 0.15);
}

.status-month-done {
    background: rgba(40, 167, 69, 0.15);
}

.company-name {
    font-weight: bold;
    color: #3d3d3d;
}
</style>
